// Constants derived from the Cologuard Order Requisition Form
// SOP-QA-1001-b, v8.0 — Exact Sciences Laboratories, LLC

export const COLOGUARD_QUESTIONNAIRE_ID = 'cologuard-order-requisition'

export interface CologuardFormState {
  // Provider Information
  healthcareOrgName: string
  providerName: string
  npi: string
  locationAddress: string
  locationCityStateZip: string
  phoneNumber: string
  secureFaxNumber: string

  // Order Information
  diagnosisText: string
  providerSignatureDataUrl: string
  providerSignatureDate: string

  // Patient Demographics
  patientIdMrn: string
  firstName: string
  lastName: string
  dateOfBirth: string // MM/DD/YYYY
  sex: 'male' | 'female' | ''
  email: string
  shippingAddress: string
  poBoxApt: string
  shippingCityStateZip: string
  patientPhone: string
  phoneType: 'home' | 'mobile' | 'work' | ''
  languagePreference: 'english' | 'spanish' | 'other' | ''

  // Billing Address
  billingAddress: string
  billingCityStateZip: string
  sameAsShipping: boolean

  // Ethnicity & Race (optional)
  hispanicLatino: 'yes' | 'no' | ''
  raceWhite: boolean
  raceBlack: boolean
  raceAsian: boolean
  raceNativeHawaiian: boolean
  raceAmericanIndian: boolean
  raceOther: boolean
  raceOtherText: string

  // Insurance / Billing
  billInsurance: 'yes' | 'no' | ''
  policyholderName: string
  policyholderDob: string // MM/DD/YYYY
  relationshipToPatient: 'self' | 'spouse' | 'other' | ''
  primaryInsuranceCarrier: string
  insuranceType: 'private' | 'medicare' | 'medicareAdvantage' | 'medicaid' | 'tricare' | ''
  claimsSubmissionAddress: string
  subscriberIdPolicyNumber: string
  groupNumber: string
  plan: string
  priorAuthCode: string
}

export function createInitialCologuardFormState(): CologuardFormState {
  return {
    // Provider
    healthcareOrgName: '',
    providerName: '',
    npi: '',
    locationAddress: '',
    locationCityStateZip: '',
    phoneNumber: '',
    secureFaxNumber: '',

    // Order
    diagnosisText: '',
    providerSignatureDataUrl: '',
    providerSignatureDate: '',

    // Patient Demographics
    patientIdMrn: '',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    sex: '',
    email: '',
    shippingAddress: '',
    poBoxApt: '',
    shippingCityStateZip: '',
    patientPhone: '',
    phoneType: 'mobile',
    languagePreference: 'english',

    // Billing Address
    billingAddress: '',
    billingCityStateZip: '',
    sameAsShipping: true,

    // Ethnicity & Race
    hispanicLatino: '',
    raceWhite: false,
    raceBlack: false,
    raceAsian: false,
    raceNativeHawaiian: false,
    raceAmericanIndian: false,
    raceOther: false,
    raceOtherText: '',

    // Insurance / Billing
    billInsurance: 'yes',
    policyholderName: '',
    policyholderDob: '',
    relationshipToPatient: '',
    primaryInsuranceCarrier: '',
    insuranceType: '',
    claimsSubmissionAddress: '',
    subscriberIdPolicyNumber: '',
    groupNumber: '',
    plan: '',
    priorAuthCode: '',
  }
}
